import gql from 'graphql-tag';

export default gql`
  fragment salesforceContactRecordTypeFragment on SalesforceContactRecordType {
    id
    name
    recordTypeId
    isMaster
  }
`;
